import { render, staticRenderFns } from "./viewButton.vue?vue&type=template&id=3c027542&scoped=true"
import script from "./viewButton.vue?vue&type=script&lang=js"
export * from "./viewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c027542",
  null
  
)

export default component.exports